import Auth from '~models/auth'
import AuthRepository from '~repositories/impl/auth-repository'

import { useMutation, UseMutationOptions } from '@tanstack/react-query'

const useSendOtpToPhoneNumber = (
  options?: UseMutationOptions<{ token: string }, Error, Auth.SendOtpToPhoneNumber>
) => {
  return useMutation({
    ...options,
    mutationFn: AuthRepository.sendOtpToPhoneNumber,
  })
}

export default useSendOtpToPhoneNumber
